
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as addD892p5BtTOMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/add.vue?macro=true";
import { default as indexKl72l0kcNAMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/index.vue?macro=true";
import { default as loginHFbWuMZn90Meta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/login.vue?macro=true";
import { default as posnAoTeaJUeoMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/pos.vue?macro=true";
import { default as qrcodeNcU0PRNpN8Meta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/qrcode.vue?macro=true";
import { default as sentry_45testwycVfE7EkMMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/sentry-test.vue?macro=true";
import { default as summaryaRf8EMhIshMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/summary.vue?macro=true";
import { default as cartT4VOMf9NJ8Meta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/cart.vue?macro=true";
import { default as indexxwGO7VEumVMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/index.vue?macro=true";
import { default as invalidBMlEmbf7D3Meta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/invalid.vue?macro=true";
import { default as login7P3awcyHq2Meta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/login.vue?macro=true";
import { default as menutvqyrfyi2JMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/menu.vue?macro=true";
import { default as qrcode48jlCReAowMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/qrcode.vue?macro=true";
import { default as summaryXVp3GmMB2JMeta } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/summary.vue?macro=true";
export default [
  {
    name: "add",
    path: "/add",
    meta: addD892p5BtTOMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/add.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexKl72l0kcNAMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginHFbWuMZn90Meta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/login.vue")
  },
  {
    name: "pos",
    path: "/pos",
    meta: posnAoTeaJUeoMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/pos.vue")
  },
  {
    name: "qrcode",
    path: "/qrcode",
    meta: qrcodeNcU0PRNpN8Meta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/qrcode.vue")
  },
  {
    name: "sentry-test",
    path: "/sentry-test",
    meta: sentry_45testwycVfE7EkMMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/sentry-test.vue")
  },
  {
    name: "summary",
    path: "/summary",
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/summary.vue")
  },
  {
    name: "v3-cart",
    path: "/v3/cart",
    meta: cartT4VOMf9NJ8Meta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/cart.vue")
  },
  {
    name: "v3",
    path: "/v3",
    meta: indexxwGO7VEumVMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/index.vue")
  },
  {
    name: "v3-invalid",
    path: "/v3/invalid",
    meta: invalidBMlEmbf7D3Meta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/invalid.vue")
  },
  {
    name: "v3-login",
    path: "/v3/login",
    meta: login7P3awcyHq2Meta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/login.vue")
  },
  {
    name: "v3-menu",
    path: "/v3/menu",
    meta: menutvqyrfyi2JMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/menu.vue")
  },
  {
    name: "v3-qrcode",
    path: "/v3/qrcode",
    meta: qrcode48jlCReAowMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/qrcode.vue")
  },
  {
    name: "v3-summary",
    path: "/v3/summary",
    meta: summaryXVp3GmMB2JMeta || {},
    component: () => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/pages/v3/summary.vue")
  }
]